module.exports = __webpack_public_path__ + "static/media/edit.bdb7f51f.svg";